export default [
  {
    path: '/terminos',
    name: 'legal-terms',
    component: () => import('@/views/legal/LegalPage.vue'),
    meta: {
      layout: 'full',
      fullEvenWhenLoggedIn: true,
      legalKind: 'terms',
    },
  },
  {
    path: '/privacidad',
    name: 'legal-privacy',
    component: () => import('@/views/legal/LegalPage.vue'),
    meta: {
      layout: 'full',
      fullEvenWhenLoggedIn: true,
      legalKind: 'privacy',
    },
  },
  {
    path: '/completa-tu-cuenta',
    name: 'complete-account',
    component: () => import('@/views/authentication/CompleteAccount.vue'),
    meta: {
      layout: 'full',
      fullEvenWhenLoggedIn: true,
      requiresAuth: true,
    },
  },
]
